























import Vue from 'vue';
import AppNavbar from '@/components/App/AppNavbar.vue';
import AppFooter from '@/components/App/AppFooter.vue';
import AppPreloader from '@/components/App/AppPreloader.vue';
import BackToTopButton from '@/components/App/BackToTopButton.vue';
import axios from 'axios';
import { Component } from 'vue-property-decorator';
import LoginView from '@/views/LoginView.vue';

@Component({
  components: {
    LoginView,
    AppNavbar,
    AppFooter,
    AppPreloader,
    BackToTopButton
  }
})
export default class App extends Vue {
  showPreloader = false;

  fab = false;

  get user() {
    return this.$store.state.user;
  }

  created() {
    axios.defaults.withCredentials = true;
  }
}
